import {EntitySelectorMode} from "./@const"

// Everything a host decides about the SHELL -- the box and its chrome. One entry
// per mode, so switching hosts is switching modes and nothing else.
//
// What a host puts IN the shell (which tabs, which project, which mentions) is
// NOT here: those follow from what is being picked, not from where the selector
// is standing, and they stay props on `EntitySelector`.
export type EntitySelectorModeConfig = {
    // Goes on the root, next to `gd-entity-selector`. `in-popover` is the one
    // with rules behind it (see selector.scss); `in-modal` is a styling hook and
    // a DOM that says which host it is.
    className   : string

    // The popover is a fixed box of its own; in a modal the modal is the box.
    width       : number | string
    height      : number | string

    // The sidebar heading and the content column's title row -- one box across
    // both panels, so one flag for the pair (see `EntitySelector`). A popover
    // has neither: it dismisses on an outside click, which makes an "x" the
    // wrong affordance, and a bare entity type over nothing is not a heading.
    hasTitleRow : boolean
}

export const ENTITY_SELECTOR_MODE_CONFIG: Record<EntitySelectorMode, EntitySelectorModeConfig> = {

    [EntitySelectorMode.POPOVER]: {
        className   : 'in-popover',
        width       : 600,
        height      : 400,
        hasTitleRow : false
    },

    [EntitySelectorMode.MODAL]: {
        className   : 'in-modal',
        width       : '100%',
        height      : '100%',
        hasTitleRow : true
    }
}
